import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import {
  QUEUE_SYMBOLS,
  RANK_SYMBOL_TO_STR,
  ROLE_SYMBOL_TO_STR,
} from "@/game-lol/constants/constants.mjs";
import * as GraphQLTemplatesDatalake from "@/game-lol/graphql-templates-datalake.mjs";
import ChampionSynergies from "@/game-lol/models/lol-champion-synergies.mjs";
import QueueSymbol, {
  getQueueDetails,
} from "@/game-lol/utils/symbol-queue.mjs";
import { RankSymbol } from "@/game-lol/utils/symbol-rank.mjs";
import RoleSymbol from "@/game-lol/utils/symbol-role.mjs";
import { queryGQL } from "@/util/gql-formatters.mjs";

// Champion synergies
// Singular (single champion)
// State location: ["lol", "championSynergies", championId, urlParams.toString()],

function queryChampionSynergies(
  variables: {
    championId: number;
    role: string;
    duoRole?: string;
    queue: string;
    tier?: string;
    region?: string;
  },
  urlParams: URLSearchParams,
) {
  const params = {
    queue: getQueueDetails(QueueSymbol(variables.queue))?.gql,
    tier: variables.tier
      ? RANK_SYMBOL_TO_STR[RankSymbol(variables?.tier)].gql
      : null,
    champion_id: "",
    individual_position: null,
    ally_individual_position: null,
    region: null,
  };

  if (
    QueueSymbol(params.queue) !== QUEUE_SYMBOLS.rankedSoloDuo &&
    QueueSymbol(params.queue) !== QUEUE_SYMBOLS.rankedFlex
  ) {
    delete params.tier;
  }

  if (variables.region) {
    params.region = variables.region;
  } else if (!params.region) {
    delete params.region;
  }

  if (variables.championId) {
    params.champion_id = `${variables.championId}`;
  } else {
    throw new Error("Champion ID is required to fetch champion matchups");
  }

  if (variables.role) {
    params.individual_position =
      ROLE_SYMBOL_TO_STR[RoleSymbol(variables?.role)]?.gql;
  } else if (urlParams.get("role")) {
    params.individual_position =
      ROLE_SYMBOL_TO_STR[RoleSymbol(urlParams.get("role"))]?.gql;
  } else if (!params.individual_position) {
    delete params.individual_position;
  }

  if (variables.duoRole) {
    params.ally_individual_position =
      ROLE_SYMBOL_TO_STR[RoleSymbol(variables?.duoRole)]?.gql;
  } else if (urlParams.get("duoRole")) {
    params.ally_individual_position =
      ROLE_SYMBOL_TO_STR[RoleSymbol(urlParams.get("duoRole"))]?.gql;
  }

  return queryGQL(
    appURLs.DATALAKE,
    GraphQLTemplatesDatalake.ChampionSynergies,
    params,
  );
}

export default function ({
  filters,
  urlParams,
  options = {},
}: {
  filters: {
    championId: number;
    role: string;
    duoRole?: string;
    queue: string;
    region?: string;
    tier?: string;
  };
  urlParams: URLSearchParams;
  options;
}) {
  return getData(
    queryChampionSynergies(filters, urlParams),
    ChampionSynergies,
    ["lol", "championSynergies", filters.championId, urlParams.toString()],
    {
      ...options,
      // shouldFetchIfPathExists: false,
      // expiryTime: Date.now() + 12 * 60 * 60 * 1000, // 12 hours
    },
  );
}
